/* eslint-disable react-hooks/exhaustive-deps */
import {
  EditOutlined,
  ArrowUpOutlined,
  PlusOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { Table, Button, message, Modal, Input, Card } from "antd";
import { useTranslation } from "react-i18next";
import { animateScroll as scroll } from "react-scroll";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../Styles/GetProducts.css";
import "../Styles/ListPages.css";
import { formatCurrency } from "../../utils/formatters";
import { apiClient } from "../Api/AllApi";

const GetProducts = () => {
  const [SearchText, setSearchText] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [loading, setLoading] = useState(true); // Add loading state

  const { t, i18n } = useTranslation();

  useEffect(() => {
    getApiProducts();
  }, [i18n.language]);
  const getApiProducts = async () => {
    setLoading(true); // Set loading to true before fetching
    try {
      const response = await apiClient.get(`/products`);

      const productsData = response.data;

      setDataSource(
        productsData.map((item) => {
          let nameObj = { en: "N/A", ar: "N/A" };
          let unitObj = { en: "N/A", ar: "N/A" };
          let image = item.image_url ? item.image_url : null;

          try {
            nameObj = item.name ? JSON.parse(item.name) : { en: "N/A" };
          } catch (error) {
            console.warn("Error parsing name:", error);
          } try {
            unitObj =
              item.unit.name && item.unit.name
                ? JSON.parse(item.unit.name)
                : { en: "N/A" };
          } catch (error) {
            console.warn("Error parsing unit:", error);
          }          // Extract sub unit name, ratio, and price and combine them
          let subUnitName = "-";
          let subUnitRatio = "-";
          let combinedSubUnitInfo = "-";
          let subUnitPrice = "-";

          if (item.sub_unit && item.sub_unit.name) {
            try {
              const subUnitObj = JSON.parse(item.sub_unit.name); subUnitName = subUnitObj[i18n.language] || subUnitObj.en || "-";
              subUnitRatio = item.sub_unit_ratio || "-";
              subUnitPrice = item.sub_unit_price ? formatCurrency(item.sub_unit_price, t("IQD")) : "-";

              // Combine ratio and name in one field (ratio first, no parentheses)
              if (subUnitName !== "-" && subUnitRatio !== "-") {
                combinedSubUnitInfo = `${subUnitRatio} ${subUnitName}`;
              } else if (subUnitName !== "-") {
                combinedSubUnitInfo = subUnitName;
              }
            } catch (error) {
              console.warn("Error parsing sub unit name:", error);
            }
          } return {
            id: item.id,
            nameKurdish: nameObj[i18n.language] || nameObj.en || "N/A",
            Unit: unitObj[i18n.language] || nameObj.en || "N/A",
            price: formatCurrency(item.price, t("IQD")),
            sku: item.sku,
            stock: item.stock,
            combinedSubUnitInfo: combinedSubUnitInfo,
            image: image,
            subUnitPrice: subUnitPrice,            weight: item.weight ? item.weight : '-',
            total_weight: item.total_weight ? `${item.total_weight} Kg` : '-',            category: item.category ? (() => {
              try {
                const categoryObj = JSON.parse(item.category.name);
                // Use the current language, with fallback to English
                return categoryObj[i18n.language] || categoryObj.en || "-";
              } catch (error) {
                console.warn("Error parsing category name:", error);
                return "-";
              }
            })() : "-"
          };
        })
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      message.error(t("errorFetchingProducts"));
    } finally {
      setLoading(false); // Set loading to false after fetching
    }
  };

  const handleDelete = (id) => {
    setDeleteItemId(id);
    setIsDeleteModalVisible(true);
  };
  const handleConfirmedDelete = async () => {
    try {
      await apiClient.delete(`/products/${deleteItemId}`);

      message.success(t("Product deleted successfully"));
      getApiProducts();
      setDeleteItemId(null);
      setIsDeleteModalVisible(false);
    } catch (error) {
      console.error("Error deleting product:", error);
      message.error(t("Error deleting product"));
    }
  };

  const columns = [
    {
      title: <span style={{ fontWeight: "bold" }}>id</span>,
      key: "index",
      render: (text, record, index) => index + 1,
    },    {
      title: <span style={{ fontWeight: "bold" }}>{t("name")}</span>,
      dataIndex: "nameKurdish",
      key: "nameKurdish",
      filteredValue: [SearchText],
      onFilter: (value, record) => {
        return (
          String(record.name).toLowerCase().includes(value.toLowerCase()) ||
          String(record.id).toLowerCase().includes(value.toLowerCase())
        );
      },
    },
    {
      title: <span style={{ fontWeight: "bold" }}>{t("price")}</span>,
      dataIndex: "price",
      key: "price",
    },
    {
      title: <span style={{ fontWeight: "bold" }}>{t("categories")}</span>,
      dataIndex: "category",
      key: "category",
    },
    {
      title: <span style={{ fontWeight: "bold" }}>{t("unit")}</span>,
      dataIndex: "Unit",
      key: "Unit",
    },
    {
      title: <span style={{ fontWeight: "bold" }}>{t("یەکەی ژێر")}</span>,
      dataIndex: "combinedSubUnitInfo",
      key: "combinedSubUnitInfo",
    },
    {
      title: <span style={{ fontWeight: "bold" }}>{t("نرخی یەک ژێر یەکە")}</span>,
      dataIndex: "subUnitPrice",
      key: "subUnitPrice",
    },
    {
      title: <span style={{ fontWeight: "bold" }}>{t("sku")}</span>,
      dataIndex: "sku",
      key: "sku",
    },
    {
      title: <span style={{ fontWeight: "bold" }}>{t("stock")}</span>,
      dataIndex: "stock",
      key: "stock",
    },
    {
      title: <span style={{ fontWeight: "bold" }}>{t("کێش")}</span>,
      dataIndex: "weight",
      key: "weight",
    },
    {
      title: <span style={{ fontWeight: "bold" }}>{t("کۆی گشتی کێش")}</span>,
      dataIndex: "total_weight",
      key: "total_weight",
    },
    {
      title: <span style={{ fontWeight: "bold" }}>{t("کۆی گشتی بابەت")}</span>,
      dataIndex: "totalValue",
      key: "totalValue",
      render: (text, record) => {
        // price is formatted, so parse it to number
        const priceNum = typeof record.price === 'string' ? Number(record.price.replace(/[^\d.-]/g, '')) : record.price;
        const total = priceNum * (parseFloat(record.stock) || 0);
        return formatCurrency(total, t("IQD"));
      },
    },
    {
      title: <span style={{ fontWeight: "bold" }}>{t("delete")}</span>,
      key: "action",
      render: (text, record) => (
        <Button
          type="primary"
          danger
          style={{
            padding: "5px 10px",
            borderRadius: "8px",
            margin: "0 5px",
          }}
          onClick={() => handleDelete(record.id)}
        >
          <DeleteOutlined />
        </Button>
      ),
    },
    {
      title: <span style={{ fontWeight: "bold" }}>{t("edit")}</span>,
      key: "action",
      render: (text, record) => (
        <Link to={`/GetProducts/UpdateProducts/${record.id}`}>
          <Button
            type="primary"
            icon={<EditOutlined />}
            style={{
              padding: "5px 10px",
              margin: "0 5px",
              borderRadius: "4px",
            }}
          ></Button>
        </Link>
      ),
    },
  ];

  const totalPrice = dataSource.reduce(
    (total, item) => total + item.price * item.stock,
    0
  );

  // Calculate total value and total weight sums for the footer
  const totalValueSum = dataSource.reduce((sum, item) => {
    const priceNum = typeof item.price === 'string' ? Number(item.price.replace(/[^\d.-]/g, '')) : item.price;
    return sum + (priceNum * (parseFloat(item.stock) || 0));
  }, 0);
  // Correct total weight: sum of (weight * stock) for each product
  const totalWeightSum = dataSource.reduce((sum, item) => {
    const weight = parseFloat(item.weight);
    const stock = parseFloat(item.stock);
    if (!isNaN(weight) && !isNaN(stock)) {
      return sum + (weight * stock);
    }
    return sum;
  }, 0);

  const scrollToTop = () => {
    scroll.scrollToTop();
  };

  return (
    <div className="list-page">
      <Card
        title={
          <span style={{ fontWeight: "600", fontSize: "1.125rem" }}>
            {t("productList")}
          </span>
        }
        bordered={false}
      >
        <Input.Search
          placeholder={t("searchPlaceholder")}
          style={{
            marginBottom: 15,
            marginTop: 12,
            width: "100%",
            maxWidth: "400px",
            borderRadius: "5px",
            padding: "8px 12px",
            margin: "0 auto 20px auto",
            boxSizing: "border-box",
          }}
          onSearch={(value) => setSearchText(value)}
          onChange={(e) => setSearchText(e.target.value)}
        />
        <Button
          type="primary"
          className="scroll-to-top-button"
          onClick={scrollToTop}
          style={{
            position: "fixed",
            bottom: "30px",
            right: "30px",
            borderRadius: "50%",
            backgroundColor: "#1890ff",
            color: "white",
          }}
        >
          <ArrowUpOutlined />
        </Button>
        <Link to="/AddProducts">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            style={{
              marginBottom: "20px",
              padding: "8px 16px",
              borderRadius: "5px",
              width: "100%",
              maxWidth: "300px",
              display: "block",
              margin: "0 auto 20px auto",
            }}
          >
            {t("زیادکردی بابەت")}
          </Button>
        </Link>
        <Table
          loading={loading}
          dataSource={dataSource.map((item) => ({ ...item, key: item.id }))}
          columns={columns}
          pagination={{ pageSize: 50 }}
          scroll={{ x: 800 }}
          summary={() => (
            <Table.Summary.Row style={{ backgroundColor: "#f9f9f9", fontWeight: "bold" }}>
              <Table.Summary.Cell colSpan={7} />
              <Table.Summary.Cell
                colSpan={1}
                style={{
                  fontWeight: "bold",
                  color: "#1d1d1d",
                  backgroundColor: "#eaf1f7",
                  borderRadius: "5px",
                  padding: "10px",
                  fontSize: "16px",
                  textAlign: "right",
                }}
              >
                {t("totalPrice")}: {formatCurrency(totalPrice, t("IQD"))}
              </Table.Summary.Cell>
              <Table.Summary.Cell colSpan={2} style={{ textAlign: 'right', fontWeight: 'bold', background: '#fffbe6' }}>
                {t('totalValue')}: {formatCurrency(totalValueSum, t('IQD'))}
              </Table.Summary.Cell>
              <Table.Summary.Cell colSpan={2} style={{ textAlign: 'right', fontWeight: 'bold', background: '#e6f7ff' }}>
                {t('کۆی گشتی کێش')}: {totalWeightSum.toLocaleString(undefined, { minimumFractionDigits:0, maximumFractionDigits: 2 })} Kg
              </Table.Summary.Cell>
            </Table.Summary.Row>
          )}
        />
      </Card>

      <Modal
        style={{ direction: "rtl" }}
        title={t("confirmDelete")}
        open={isDeleteModalVisible}
        onOk={handleConfirmedDelete}
        onCancel={() => setIsDeleteModalVisible(false)}
        okText={t("confirm")}
        cancelText={t("cancel")}
      >
        <p>{t("confirmDeleteMessage")}</p>
      </Modal>
    </div>
  );
};

export default GetProducts;
